import { lazyWithRetry as lazy } from '@utils/lazyWithRetry';
import { RouteConfig } from '@routes/types';
import HomeWrapper from '@page/HomeWrapper';

const ContractorPortalHome = lazy(
  () => import('@component/ContractorPortal/ContractorPortalHome')
);
const ContractorPortalAdmin = lazy(
  () => import('@component/ContractorPortal/ContractorPortalAdmin')
);
const ContractorPortalPayerInvitations = lazy(
  () => import('@component/ContractorPortal/ContractorPortalPayerInvitations')
);
const ContractorPortalPermissions = lazy(
  () => import('@component/ContractorPortal/ContractorPortalPermissions')
);
const ContractorPortalContractorInfo = lazy(
  () => import('@component/ContractorPortal/ContractorPortalContractorInfo')
);
const ContractorPortalAuditLogs = lazy(
  () => import('@component/ContractorPortal/ContractorPortalAuditLogs')
);
const ContractorPortalNotifications = lazy(
  () => import('@component/ContractorPortal/ContractorPortalNotifications')
);
const ContractorPortalStandingOrders = lazy(
  () => import('@component/ContractorPortal/ContractorPortalStandingOrders')
);
const ContractorPortalAssignmentScreen = lazy(
  () => import('@component/ContractorPortal/ContractorPortalAssignmentScreen')
);
const ContractorPortalDriverMap = lazy(
  () => import('@component/ContractorPortal/ContractorPortalDriverMap')
);
const ContractorPortalCredentialingContractor = lazy(
  () =>
    import(
      '@component/ContractorPortal/Credentialing/ContractorPortalCredentialingContractor'
    )
);
const ContractorPortalCredentialingDrivers = lazy(
  () =>
    import(
      '@component/ContractorPortal/Credentialing/ContractorPortalCredentialingDrivers'
    )
);
const ContractorPortalCredentialingPersonnel = lazy(
  () =>
    import(
      '@component/ContractorPortal/Credentialing/ContractorPortalCredentialingPersonnel'
    )
);
const PersonnelRecord = lazy(
  () =>
    import(
      '@component/ContractorPortal/Credentialing/Personnel/PersonnelRecord/PersonnelRecord'
    )
);
const ContractorPortalCredentialingVehicles = lazy(
  () =>
    import(
      '@component/ContractorPortal/Credentialing/ContractorPortalCredentialingVehicles'
    )
);
const ProfileAuditLogs = lazy(
  () => import('@component/Profile/ProfileAuditLogs')
);
const ProfilePermissions = lazy(
  () => import('@component/Profile/ProfilePermissions/ProfilePermissions')
);
const ProfileRecentActivity = lazy(
  () => import('@component/Profile/ProfileRecentActivity/ProfileRecentActivity')
);
const ProfileUserProfile = lazy(
  () => import('@component/Profile/ProfileUserProfile')
);

const PageNotFound = lazy(() => import('@component/PageNotFound/PageNotFound'));
const IconsWrapper = lazy(() => import('@page/IconsWrapper'));
const SomethingWentWrong = lazy(
  () => import('@component/SomethingWentWrong/SomethingWentWrong')
);
const NoAuthorization = lazy(
  () => import('@component/NoAuthorization/NoAuthorization')
);
const ConfigWrapper = lazy(() => import('@page/ConfigWrapper'));

export const contractorPortalRoutes: RouteConfig[] = [
  {
    path: '/',
    element: HomeWrapper,
    children: [
      {
        path: '',
        element: ContractorPortalHome,
      },
      {
        path: 'admin/users',
        element: ContractorPortalAdmin,
      },
      {
        path: 'admin/payer-invitations',
        element: ContractorPortalPayerInvitations,
      },
      {
        path: 'admin/permissions',
        element: ContractorPortalPermissions,
      },
      {
        path: 'contractors/information',
        element: ContractorPortalContractorInfo,
      },
      {
        path: 'contractors/standing-orders',
        element: ContractorPortalStandingOrders,
      },
      {
        path: 'contractors/audit-logs',
        element: ContractorPortalAuditLogs,
      },
      {
        path: 'contractors/notifications',
        element: ContractorPortalNotifications,
      },
      {
        path: 'credentialing/contractor',
        element: ContractorPortalCredentialingContractor,
      },
      {
        path: 'credentialing/personnel',
        element: ContractorPortalCredentialingPersonnel,
      },
      {
        // named :id so the breadcrumbs drop the number like on other records
        path: 'credentialing/personnel/:id',
        element: PersonnelRecord,
      },
      {
        path: 'credentialing/drivers',
        element: ContractorPortalCredentialingDrivers,
      },
      {
        path: 'credentialing/vehicles',
        element: ContractorPortalCredentialingVehicles,
      },
      {
        path: 'assignment-screen',
        element: ContractorPortalAssignmentScreen,
      },
      {
        path: 'driver-map',
        element: ContractorPortalDriverMap,
      },
      {
        path: 'user-profile',
        element: ProfileUserProfile,
      },
      {
        path: 'audit-logs',
        element: ProfileAuditLogs,
      },
      {
        path: 'permissions',
        element: ProfilePermissions,
      },
      {
        path: 'recent-activity',
        element: ProfileRecentActivity,
      },
    ],
  },
  {
    path: 'icons',
    element: IconsWrapper,
  },
  {
    path: 'configs',
    element: ConfigWrapper,
  },
  {
    path: 'wrong',
    element: SomethingWentWrong,
  },
  {
    path: 'no-authorization',
    element: NoAuthorization,
  },
  {
    path: '*',
    element: PageNotFound,
  },
];
